import React from "react";
import Button from "../../button/button";
import DropdownButton, {
  IDropdownMenuOption,
} from "../../dropdown-button/dropdown-button";

import './report-buttons.scss'
import { SxProps } from "@mui/material";

export interface IActionButtons {
  title?: string;
  icon?: React.ReactNode;
  btnStyle?: "WhiteBtn";
  variant?: "text" | "outlined" | "contained";
  action?: () => void;
  class?: string;
  disabled?: boolean;
}

export interface IReportButtons {
  className?: string;
  buttons?: IActionButtons[];
  dropdownMenuButtonData?: {
    icon?: React.ReactNode;
    children?: React.ReactNode;
    options: IDropdownMenuOption[];
    sx?: SxProps;
  } | null;
  toggleCallback?: (e?: boolean) => void;
  zIndex?: number;
}

const ReportButtons = ({ buttons, dropdownMenuButtonData = null, toggleCallback, className, zIndex = 999 }: IReportButtons) => {
  return (
    <div className={className}>
      {buttons?.map((ele) => (
        <Button
          className={
            ele.class
              ? ele.class
              : `wrapper--${ele?.btnStyle}`
          }
          key={ele.title}
          variant={ele.variant ? ele.variant : "contained"}
          startIcon={ele.icon ? ele.icon : ""}
          disabled={Boolean(ele.disabled)}
          onClick={ele.action}
        >
          {ele.title ?? ""}
        </Button>
      ))}
      {dropdownMenuButtonData && (
        <div style={{ zIndex }}>
          <DropdownButton
            options={dropdownMenuButtonData.options || []}
            startIcon={dropdownMenuButtonData.icon}
            isMenuThirdItemDisabled={true}
            isOnlyDropDownButton={true}
            variant={"text"}
            buttonGroupProps={{
              variant: "text",
              sx: ({palette}) => ({
                "& .MuiButton-root": {
                  border: "1px solid !important",
                  borderColor: `${palette.grey[200]} !important`,
                  borderRadius: "20px",
                  pt: 0.25,
                  pb: 0.25,
                  pr: 0.75,
                  color: `${palette.grey[800]} !important`,
                  ':hover': {
                    bgcolor: `${palette.grey[200]} !important`
                  }
                },
              }),
            }}
            onlyDropDownButtonProps={{
              style: {
                backgroundColor: "white !important",
                color: "black !important",
                ...dropdownMenuButtonData.sx
              },
            }}
            toggleCallback={toggleCallback}
          >
            {dropdownMenuButtonData.children}
          </DropdownButton>
        </div>
      )}
    </div>
  );
};
export { ReportButtons };
export default ReportButtons;
